// File: custom-renderer.js
// Import Highway
import Highway from './highway';
import loadComponents from 'gia/loadComponents';
import removeComponents from 'gia/removeComponents';
import _each from 'lodash.foreach'


import Cover from './cover'
import Loader from './loader'
import Faq from './faq'

import Nav from './nav'
import Contact from './contact'
import Popup from './popup'
import Animation from './animation'
import Reservations from './reservations'
import Menu from './menu'
import News from './news'
import Modal from './modal'
import Inspiration from './inspiration'


import gsap from 'gsap'
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
gsap.registerPlugin(ScrollTrigger);

class CustomRenderer extends Highway.Renderer {
  // Hooks/methods
  // constructor(){
  //   super()


  // }

  onEnter() {
     
      
      document.body.classList.add('has-nav')
     
   
  }
  onLeave() {

    document.body.classList.add('menu-loading')
    this.removeClassByPrefix(document.body, 'menu-color-')
   
    document.body.classList.remove('has-nav')
    document.body.classList.remove('hidemenu')
    document.body.classList.remove('is-home')
    document.body.classList.remove('is-started')
    document.body.classList.add('menuinit')
    

  }
  onEnterCompleted(e) {
      document.body.classList.remove('menu-loading')

      const components = {

            Popup: Popup, 
            Animation: Animation,
            Contact: Contact,
            Faq: Faq,
            News: News,
            Menu: Menu,
            Cover: Cover,
            Loader: Loader,
            Nav: Nav,
            Reservations: Reservations,
            Modal: Modal,
            Inspiration: Inspiration

      }

   

      loadComponents(components, document.getElementById('main'))

    

  }
  onLeaveCompleted() {
      
    
      removeComponents(document.getElementById('main'))
      
  }

  removeClassByPrefix(node, prefix) {
    var regx = new RegExp('\\b' + prefix + '[^ ]*[ ]?\\b', 'g');
    node.className = node.className.replace(regx, '');
    return node;
  }
}

// Don`t forget to export your renderer
export default CustomRenderer;
